import { observer } from 'mobx-react-lite';
import { Box, Flex, Heading, Text, Dialog, IconButton, Button } from '@radix-ui/themes';
import { ChangeEvent, ReactNode } from 'react';
import { FormField } from 'shared/components';
import { AutocompleteV2 } from 'shared/components/autocomplete-v2';
import { WithoutResumeStore } from './WithoutResume.store';
import InputDate from 'Components/forms/components/InputDate';
import { useDebouncedCallback } from 'use-debounce';

function MissingFieldsView({ store }: { store: WithoutResumeStore }) {
  
   const debouncedCities = useDebouncedCallback((q) => {
      store.searchCityStore.getCities({ query: q });
   }, 500);

   return (
      <Box mt="3">
         <Box mb="3">
            <FormField
               label="Місто"
               labelHighContrast
               htmlFor="city_id"
               required
               weight="medium"
               error={store.form.controls['city_id'].error}
            >
               <AutocompleteV2.Root
                  placeholder="Оберіть місто"
                  selectedKey={store.form.controls['city_id'].value || null}
                  items={store.searchCityStore.cities}
                  loading={store.searchCityStore.citiesLoading}
                  getOptionValue={(city) => city.id}
                  getOptionLabel={(city) => city.name}
                  onSelect={(loc) => {
                     store.searchCityStore.setSelected(loc);
                     store.form.controls['city_id'].setValue(loc.id);
                  }}
                  onSearch={(v) => {
                     store.form.controls['city_id'].setValue('');
                     debouncedCities(v);
                  }}
               ></AutocompleteV2.Root>
            </FormField>
         </Box>

         <Box mb="4">
            <FormField
               label="Дата народження"
               labelHighContrast
               htmlFor="birthday"
               required
               weight="medium"
               error={store.form.controls['birthday'].error}
            >
               <InputDate
                  name="birthday"
                  minDate="1930-01-01"
                  value={store.form.controls['birthday'].value}
                  handleChange={(e: ChangeEvent<HTMLInputElement>) => {
                     store.form.controls['birthday'].setValue(e.target.value);
                  }}
                  maxDate={new Date().toISOString().split('T')[0]}
                  error={undefined}
                  label={undefined}
                  touched={undefined}
                  required={undefined}
                  handleBlur={undefined}
               />
            </FormField>
         </Box>
      </Box>
   );
}

export const MissingFieldsForm = observer(MissingFieldsView);
